angular.module('impactx.chiplist').component('ixChipList', {
        bindings: {
            entries: '<',
            onSelect: '&'
        },
        controller: 'ChipListCtrl',
        templateUrl: 'shared/chips/templates/chip-list.html'
    }
);